var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkModeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3D3D3D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0542 5.67237C12.1832 5.90129 12.1657 6.18464 12.0095 6.39596C11.4401 7.1664 11.166 8.11564 11.2373 9.07105C11.3085 10.0265 11.7203 10.9246 12.3978 11.602C13.0752 12.2795 13.9733 12.6913 14.9287 12.7625C15.8841 12.8338 16.8334 12.5597 17.6038 11.9902C17.8151 11.834 18.0985 11.8166 18.3274 11.9456C18.5563 12.0746 18.6881 12.326 18.6639 12.5877C18.5474 13.8486 18.0742 15.0502 17.2997 16.052C16.5251 17.0538 15.4813 17.8142 14.2904 18.2444C13.0994 18.6746 11.8106 18.7567 10.5747 18.4811C9.33876 18.2055 8.20689 17.5837 7.31151 16.6883C6.41613 15.7929 5.79426 14.661 5.51868 13.4251C5.2431 12.1892 5.32521 10.9004 5.75539 9.7094C6.18557 8.51845 6.94603 7.47464 7.9478 6.70011C8.94956 5.92558 10.1512 5.45237 11.4121 5.33585C11.6737 5.31167 11.9252 5.44345 12.0542 5.67237ZM10.211 6.95906C9.69261 7.14663 9.20383 7.41437 8.76335 7.75493C7.96194 8.37456 7.35357 9.2096 7.00942 10.1624C6.66528 11.1151 6.59959 12.1462 6.82006 13.1349C7.04052 14.1237 7.53801 15.0292 8.25432 15.7455C8.97063 16.4618 9.87612 16.9593 10.8649 17.1797C11.8536 17.4002 12.8847 17.3345 13.8374 16.9904C14.7902 16.6462 15.6252 16.0378 16.2449 15.2364C16.5854 14.796 16.8532 14.3072 17.0407 13.7888C16.3386 14.0428 15.5856 14.1485 14.8296 14.0922C13.5557 13.9972 12.3582 13.4481 11.455 12.5448C10.5517 11.6416 10.0026 10.4441 9.90763 9.17021C9.85126 8.41423 9.95702 7.66114 10.211 6.95906Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkModeIcon);
export default __webpack_public_path__ + "static/media/dark_mode_icon.2c406cab98f78245a99f5b981c18ba17.svg";
export { ForwardRef as ReactComponent };